import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Checkbox} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Checkbox, {
            'children': 'checkbox',
            'ev-$model:value': function($v) {
                $this.set('value', $v);
            },
            'value': $this.get('value')
        }),
        _$cc(Checkbox, {
            'disabled': true,
            'children': 'disabled checkbox'
        }),
        _$cc(Checkbox, {
            'value': true,
            'disabled': true,
            'children': 'disabled checked checkbox'
        })
    ], 4);
};